// extracted by mini-css-extract-plugin
module.exports = {"toast":"ToastItem_toast__Cdm8d","info":"ToastItem_info__tz8QQ","success":"ToastItem_success__fIj6E","error":"ToastItem_error__wUH9b"};